/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

/* Begin Nathan G custom special pricing code */
let specialPricingCustomer = false;
let specialPricingTag;
let specialPricingDiscountData;
let discountOffRegularPercentage = 0;
let discountOffRegularPercentageInverse = 0;
let finalSpecialPricingPrice;
if($('body').hasClass('special-pricing')){
  specialPricingCustomer = true;
  specialPricingDiscountData = window.bluespace.specialPricingDiscounts['data'];
  specialPricingTag = window.bluespace.specialPricingTag;
} 

function getSpecialPricingPrice(productData) {
  let thisProductSpecialPricingDiscount = 0;
  let specialPricingDiscountObject = {
    discount: 0,
    finalPrice: 0
  }
  for(i = 0; i < specialPricingDiscountData.length; i++) {
    if(specialPricingDiscountData[i].tag == specialPricingTag) {
      if(Object.hasOwn(specialPricingDiscountData[i], 'discountOffRegular')){
        discountOffRegularPercentage = specialPricingDiscountData[i].discountOffRegular;
      }
      const discountGroup = specialPricingDiscountData[i].discounts;
      for(j = 0; j < discountGroup.length; j++) {
        if(discountGroup[j].vendor == productData.vendor) {
          thisProductSpecialPricingDiscount = discountGroup[j].general;
          if(discountGroup[j].typeDiscounts != undefined) {
            const productTypes = discountGroup[j].typeDiscounts;
            for(k = 0; k < productTypes.length; k++) {
              if(productTypes[k][productData.product_type] != undefined){
                thisProductSpecialPricingDiscount = productTypes[k][productData.product_type];
              }
            }
          }
        }
      }
    }
  }
  if(discountOffRegularPercentage !== 0){
    discountOffRegularPercentage = discountOffRegularPercentage.replace('%', '');
    discountOffRegularPercentage = parseInt(discountOffRegularPercentage);
    discountOffRegularPercentageInverse = 100 - discountOffRegularPercentage;
  }
  if(thisProductSpecialPricingDiscount != 0){
    thisProductSpecialPricingDiscount = thisProductSpecialPricingDiscount.replace('%', '');
    thisProductSpecialPricingDiscount = parseInt(thisProductSpecialPricingDiscount);
    const thisProductSpecialPricingDiscountInverse = 100 - thisProductSpecialPricingDiscount;
    let testSpecialPricingPrice = (productData.compare_at_price / 100.00 ) * thisProductSpecialPricingDiscountInverse;
    if(testSpecialPricingPrice <= productData.price) {
      finalSpecialPricingPrice = testSpecialPricingPrice;
      specialPricingDiscountObject.discount = thisProductSpecialPricingDiscount;
    } else if(discountOffRegularPercentage !== 0){
      finalSpecialPricingPrice = (productData.price / 100.00 ) * discountOffRegularPercentageInverse;
      specialPricingDiscountObject.discount = discountOffRegularPercentage;
    } else {
      finalSpecialPricingPrice = productData.price;
      specialPricingDiscountObject.discount = thisProductSpecialPricingDiscount;
    }
    specialPricingDiscountObject.finalPrice = finalSpecialPricingPrice;
    return specialPricingDiscountObject
  } else if(discountOffRegularPercentage !== 0){
    finalSpecialPricingPrice = (productData.price / 100.00 ) * discountOffRegularPercentageInverse;
    specialPricingDiscountObject.discount = discountOffRegularPercentage;
    specialPricingDiscountObject.finalPrice = finalSpecialPricingPrice;
    return specialPricingDiscountObject
  } else {
    specialPricingDiscountObject.discount = 0;
    specialPricingDiscountObject.finalPrice = productData.price;
    return specialPricingDiscountObject;
  }
}
/* Begin Nathan G custom special pricing code */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = '';
    if (comparing) {
      res +=
        ' <span class="ais-hit--price-striked price--compare-at"><span class="money">' +
        formatPrice(compare_at_price) +
        '</span></span> ';
      res +=
        ' <span class="ais-hit--price-discount" style="font-weight: ' +
        Math.floor(discount_ratio * 10) * 100 +
        ';">-' +
        Math.floor(discount_ratio * 100) +
        '%</span>';
    }
    res += '<b>' + formatPrice(price) + '</b>';
    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {

      /* Begin Nathan G custom special pricing code */
        
      if(specialPricingCustomer) {
        let specialPricingObject = {
          discount: 0,
          finalPrice: 0
        }
        specialPricingObject = getSpecialPricingPrice(this);
        return formattedPriceWithComparison(specialPricingObject.finalPrice, null);

      /* End Nathan G custom special pricing code */
      
      } else { 
        if (this._distinct) {
          var min = this.variants_min_price;
          var max = this.variants_max_price;
          if (min !== max) {
            return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
          }
        }
        return formattedPriceWithComparison(this.price, null);
      }

    },
    instantsearchPrice: function instantsearchPrice() {
       if(specialPricingCustomer) {
        let specialPricingObject = {
          discount: 0,
          finalPrice: 0
        }
        specialPricingObject = getSpecialPricingPrice(this);
        let priceToDisplay = specialPricingObject.compare_at_price;
        if(priceToDisplay != this.price) {
          return '<b>' + formattedPriceWithComparison(specialPricingObject.finalPrice, this.compare_at_price) + '</b>';
        } else {
          return '<b>' + formattedPriceWithComparison(specialPricingObject.finalPrice, null) + '</b>';
        }

        /* End Nathan G custom specialPricing code */
      } else { 
        if (this._distinct) {
          var min = this.variants_min_price;
          var max = this.variants_max_price;
          if (min !== max) {
            return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
          }
        }
        return formattedPriceWithComparison(
          this.price,
          this.compare_at_price,
          this.price_ratio
        );
      }
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (
        this._highlightResult.product_type &&
        this._highlightResult.product_type.value
      ) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.product_type.value
        );
      } else {
        return '';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value
        );
      } else {
        return '';
      }
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
